import React, { useState, useCallback, useEffect } from 'react';
import {
  Button, Modal, Link, IconExternalLink,
} from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import * as Styles from './Terminal.styles';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { vpsOciActions } from '@/redux/modules';
import { useParams } from 'react-router-dom';
import useServerStatus from '@/hooks/useServerStatus';
import { useIsMobile } from '@/hooks/useIsMobile';
import { billingAnalytics } from '@/analytics';

const Terminal = () => {
  const dispatch = useDispatch();
  const { id: hostingId } = useParams();
  const isMobile = useIsMobile();

  const [openSshTerminalError, setOpenSshTerminalError] = useState(false);

  const { hostingAndServers: hostingAndServersAnalytics } = billingAnalytics;

  const {
    productName,
    terminalIsLoading,
    urlTerminal,
    serverInfo,
    isRebooting,
  } = useSelector(state => ({
    productName: state.vpsOci?.data?.productName,
    terminalIsLoading: state.vpsOci?.openSshTerminal?.loading || false,
    urlTerminal: state.vpsOci?.openSshTerminal?.url || null,
    serverInfo: state.vpsOci?.data?.serverInfo,
    isRebooting: state.vpsOci?.isRebooting,
  }), shallowEqual);

  const {
    serverDisabledFeatures,
  } = useServerStatus({
    serverInfo,
    serverId: hostingId,
  });

  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: vpsOciLocale } = productDetailsLocale;

  const handleOpenTerminal = useCallback(() => {
    dispatch(vpsOciActions.openSshTerminal.request(hostingId));
    hostingAndServersAnalytics.hostingSshOpenTerminalClick(productName);
  }, [hostingId, dispatch, hostingAndServersAnalytics, productName]);

  const handleCloseModalSshTerminalError = useCallback(() => {
    setOpenSshTerminalError(false);
  }, []);

  useEffect(() => {
    if (urlTerminal === 'error') {
      setOpenSshTerminalError(true);
    } else if (urlTerminal && urlTerminal !== 'error') {
      window.open(urlTerminal, '_blank');
    }
    dispatch(vpsOciActions.openSshTerminal.set(null));
  }, [urlTerminal, dispatch]);

  return (
    <>
      <Styles.TerminalWrapper>
        <Button
          label={vpsOciLocale.infoSsh.terminal.buttonLabel}
          variant="primary"
          onClick={(!serverDisabledFeatures && !isRebooting) ? handleOpenTerminal : undefined}
          testId="vpsoci-open-terminal-button"
          size="large"
          version="v2"
          width={isMobile ? 'full' : 'fit-content'}
          loading={terminalIsLoading}
          disabled={serverDisabledFeatures || isRebooting}
          notFillSVG
          iconRight={<IconExternalLink color={!serverDisabledFeatures && !isRebooting ? 'highPure' : 'lowLight'} secondaryColor="transparent" size="sm" />}
        />
      </Styles.TerminalWrapper>

      {openSshTerminalError && (
        <Modal
          onClose={handleCloseModalSshTerminalError}
          maxWidth={500}
          title={vpsOciLocale.infoSsh.terminal.modal.error.title}
          testId="ssh-terminal-modal-error"
        >
          <Styles.ModalContent>
            <Styles.ModalDescription>
              {vpsOciLocale.infoSsh.terminal.modal.error.message}
              {' '}
              <Link
                href={vpsOciLocale.infoSsh.terminal.modal.error.link.url}
                target="_blank"
                rel="noopener noreferrer"
                text={vpsOciLocale.infoSsh.terminal.modal.error.link.text}
              />
            </Styles.ModalDescription>
            <Styles.ModalButtonWrapper>
              <Button
                variant="primary"
                label={vpsOciLocale.infoSsh.terminal.modal.error.confirmButton}
                onClick={handleCloseModalSshTerminalError}
                testId="ssh-terminal-error-confirm-button"
                size="large"
                width="full"
              />
            </Styles.ModalButtonWrapper>
          </Styles.ModalContent>
        </Modal>
      )}


    </>
  );
};

export default Terminal;
